// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.av907W8MymtcKAOvugQe {
    position: relative;
    bottom: 9px;
    border-radius: 4px;
    background-color: white;
    padding: 16px;
    margin: 0 8px;
    animation: a2E2A9_sq9efIpxUhOQC 0.3s ease-out;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/AvailabilityShared/CalendarContent/TimeSlotSection/TimeSlotSection.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,6CAA6C;AACjD","sourcesContent":[".wrapper {\n    position: relative;\n    bottom: 9px;\n    border-radius: 4px;\n    background-color: white;\n    padding: 16px;\n    margin: 0 8px;\n    animation: L9wyXCRveIQeluYfo946 0.3s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `av907W8MymtcKAOvugQe`,
	"L9wyXCRveIQeluYfo946": `a2E2A9_sq9efIpxUhOQC`
};
export default ___CSS_LOADER_EXPORT___;
